module.exports = __webpack_public_path__ + "img/icon_edit.6ba47d48.svg";